import React, { useContext } from 'react'
import * as R from 'ramda'
import styled, { ThemeProvider } from 'styled-components'
import { AppContext } from '../../store'
import LogoAlelo from '../../assets/images/alelo-marine-logo/marine@3x.png'
import MarcaAlelo from '../../assets/images/marca-alelo-blue.png'
import './style.scss'

const pickColor = (option) => R.path(['theme', `color_${option}`])

const Container = styled.div`
  footer {
    background: ${pickColor('primary')};
  }
`

export default function Footer() {
  const { state } = useContext(AppContext)
  const { contentful } = state

  const { team: { fields = {} } = {} } = contentful || {}

  return (
    <ThemeProvider theme={fields}>
      <Container>
        <footer>
          <section className='content-container'>
            <div className='logo'>
              <a href='https://veloe.com.br/' target='_blank'>
                <img width='76px' heigth='32px' src={LogoAlelo} alt='Veloe Logo' />
              </a>
            </div>
            <div className='inform'>
              <p>© Todos os direitos reservados - Veloe 2020</p>
              <div className='section-logoElo'>
                <img height='25px' alt='Uma marca alelo' src={MarcaAlelo} />
              </div>
            </div>
          </section>
        </footer>
      </Container>
    </ThemeProvider>
  )
}
